import {Controller} from "@hotwired/stimulus";
import {updateCart, updateWatchList} from "~/lib/badges";
import {putJson} from "~/lib/request";

// "Move to watch list" button of the cart overview (carts/current) - the reverse
// of the watch list's cart button (cart_button_controller.js): the server moves
// the position, then both header badges follow and the row goes away.
export default class extends Controller {
    static values = {courseUuid: String, courseRowUuid: String, moveUrl: String};

    move() {
        if (this.pending || !this.moveUrlValue) return;
        this.pending = true;
        putJson(this.moveUrlValue, {
            course_uuid: this.courseUuidValue,
            course_row_uuid: this.courseRowUuidValue,
        }).then((data) => {
            updateCart(data.cart_count);
            updateWatchList(data.watch_count);
            this.element.closest("tr")?.remove();
        }).catch((error) => {
            console.error("moving to the watch list failed", error);
            // hardcoded German like the other frontend controllers - the Vite
            // bundle has no gettext (see 15087-redesign-improvements.md, 4.4)
            window.alert("Das hat leider nicht geklappt. Bitte laden Sie die Seite neu und versuchen Sie es erneut.");
        }).finally(() => {
            this.pending = false;
        });
    }
}
